module.exports = __webpack_public_path__ + "media/images/icons/list-41bcb20810cf6885011dca00d934394d.svg";